import Vue from 'vue'
import Router from 'vue-router';
const Index = resolve => require(['@/components/index/index.vue'], resolve)
const Login = resolve => require(['@/components/steps/login/login.vue'], resolve)
const Agreeement = resolve => require(['@/components/steps/agreement/index.vue'], resolve)
const Baseinformation = resolve => require(['@/components/steps/baseInfor/index.vue'], resolve)
const Manageinformation = resolve => require(['@/components/steps/manageInfor/index.vue'], resolve)
const ManageRange = resolve => require(['@/components/steps/manageRange/index.vue'], resolve)
const Payfees = resolve => require(['@/components/steps/payfees/payfees.vue'], resolve)
const Checkmessage = resolve => require(['@/components/steps/checkmessage/checkmessage.vue'], resolve)
const Checkpay = resolve => require(['@/components/steps/checkpay/checkpay.vue'], resolve)
const pass = resolve => require(['@/components/steps/pass/pass.vue'], resolve)
const stopPage = resolve => require(['@/components/stopPage/index.vue'], resolve)

Vue.use(Router);
let stopPageFlag=false;

var vueRouterObj = new Router({
    routes: [
        
        {
            path: '/',
            component: stopPageFlag?stopPage:Index,
            meta: {
                auth: true
            }
        },
        {
            path: '/register/login',
            component: stopPageFlag?stopPage:Login,
            meta: {
                auth: true
            }
        },
        {
            path: '/agreement',
            component: Agreeement,
        },
        {
            path: '/baseinformation',
            component: Baseinformation
        },
        {
            path: '/manageinformation',
            component: Manageinformation
        },
        {
            path: '/managerange',
            component: ManageRange
        },
        {
            path: '/checkmessage',
            component: Checkmessage
        },
        {
            path: '/payfees',
            component: Payfees
        },
        {
            path: '/checkpay',
            component: Checkpay
        },
        {
            path: '/pass',
            component: pass
        },
        {
            path: '*',
            redirect: '/',
        },
    ]
})
// 路由拦截
vueRouterObj.beforeEach((to, from, next) => {
    if (!to.meta.auth) {
        if (sessionStorage.getItem("userLoginId") && !stopPageFlag) {
            next()
        } else {
            next({
                path: "/"
            })
        }
    } else {
        next()
    }
})
export default vueRouterObj


// WEBPACK FOOTER //
// ./src/router/index.js